(function() {
  if (window.lazyObserver) return;

  function lazyLoadElement(elem) {
    if (elem.tagName === 'VIDEO') {
      var sources = elem.querySelectorAll('source[data-src]');
      sources.forEach(function(source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      if (elem.dataset.poster) {
        elem.poster = elem.dataset.poster;
        elem.removeAttribute('data-poster');
      }
      elem.load();
      if (elem.dataset.autoplay === 'true') {
        elem.play().catch(function(){});
        elem.removeAttribute('data-autoplay');
      }
    } else if (elem.tagName === 'IFRAME' && elem.dataset.src) {
      elem.src = elem.dataset.src;
      elem.removeAttribute('data-src');
    } else if (elem.tagName === 'IMG' && elem.dataset.src) {
      elem.src = elem.dataset.src;
      elem.removeAttribute('data-src');
      if (elem.dataset.srcset) {
        elem.srcset = elem.dataset.srcset;
        elem.removeAttribute('data-srcset');
      }
    } else if (elem.dataset.bg) {
      elem.style.backgroundImage = 'url(' + elem.dataset.bg + ')';
      elem.removeAttribute('data-bg');
    }
    if (elem.tagName === 'PICTURE') {
      var picSources = elem.querySelectorAll('source[data-srcset]');
      picSources.forEach(function(source) {
        source.srcset = source.dataset.srcset;
        source.removeAttribute('data-srcset');
      });
    }
  }

  window.lazyObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var elem = entry.target;
        lazyLoadElement(elem);
        window.lazyObserver.unobserve(elem);
      }
    });
  }, { rootMargin: '300px 0px', threshold: 0 });

  function observeLazyElements(scope) {
    var container = scope || document;
    var selectors = '.lazy-video, .lazy-image, .lazy-iframe, .lazyload';
    var elements = container.querySelectorAll ? container.querySelectorAll(selectors) : [];
    elements.forEach(function(el) {
      if (window.lazyObserver) window.lazyObserver.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      observeLazyElements();
    });
  } else {
    observeLazyElements();
  }

  if (window.MutationObserver) {
    var mutationObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('.lazy-video, .lazy-image, .lazy-iframe, .lazyload, .lazy-picture')) {
              window.lazyObserver.observe(node);
            }
            if (node.querySelectorAll) {
              node.querySelectorAll('.lazy-video, .lazy-image, .lazy-iframe, .lazyload, .lazy-picture').forEach(function(el) {
                window.lazyObserver.observe(el);
              });
            }
          }
        });
      });
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  window.lazyLoadObserve = function(el) {
    if (window.lazyObserver) window.lazyObserver.observe(el);
  };

  window.lazyLoadElement = lazyLoadElement;
})();
